"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeThumbnails = exports.globalFilters = void 0;
/* eslint-disable global-require */

var typeThumbnails = {
  mp3: require('./images/mp3.svg')
};
exports.typeThumbnails = typeThumbnails;
var globalFilters = {
  audio: {
    regex: /\.mp3$/,
    accept: '.mp3'
  },
  image: {
    regex: /\.(jpg|jpeg|png|svg)$/,
    accept: '.jpg,.jpeg,.png,.svg'
  },
  pdf: {
    regex: /\.pdf$/,
    accept: '.pdf'
  }
};
exports.globalFilters = globalFilters;